export const environment = {
  production: false,
  loginPath: "/login",
  urlServer_: "https://app.zent.cloud",
  urlServer: "https://app.zent.cloud",
  urlServer_nows: "https://app.zent.cloud"
};
